import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import RingImg from '../../../Assets/images/DFL/landing-page-img/fine-jewelery-img/rings.png'
import earringsImg from '../../../Assets/images/DFL/landing-page-img/fine-jewelery-img/earrings.png'
import necklacesImg from '../../../Assets/images/DFL/landing-page-img/fine-jewelery-img/necklaces.png'
import braceletsImg from '../../../Assets/images/DFL/landing-page-img/fine-jewelery-img/bracelets.png'
import pendantsImg from '../../../Assets/images/DFL/landing-page-img/fine-jewelery-img/pendants.png'
import size_guideImg from '../../../Assets/images/DFL/landing-page-img/fine-jewelery-img/size_guide.png'

const FineCollection = () => {
    return (
        <>
            <div className='dfl_fine_collection_Section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col xs={12} sm={6} md={6} lg={6} className="content_left">
                            <div className="banner-adv zoom-image">
                                <Row className="ring_bg w-100 m-auto">
                                    <Col xs={5} sm={5} md={6} lg={6} className="ring_left_inner no-padding adv-thumb-link">
                                        <img src={RingImg} alt="Rings" />
                                    </Col>
                                    <Col xs={7} sm={7} md={6} lg={6} className="col-xs-7 content_left_inner">
                                        <h2>DIAMOND  Rings</h2>
                                        <p>The Ultimate Expression Of Love</p>
                                        <NavLink to="/jewellery/fashion-rings" className="cool-link">shop rings</NavLink>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} className="content_right">
                            <div className="banner-adv zoom-image">
                                <Row className="earring_bg w-100 m-auto">
                                    <Col xs={7} sm={7} md={6} lg={6} className="content_right_inner">
                                        <h2>DIAMOND  Earrings</h2>
                                        <p>Perfect For All Occasions</p>
                                        <NavLink to="/jewellery/diamond-earrings" className="cool-link">shop Earrings</NavLink>
                                    </Col>
                                    <Col xs={5} sm={5} md={6} lg={6} className="dfl_finr_coll_bracelet_img no-padding adv-thumb-link desktop_view">
                                        <img src={earringsImg} alt="Earrings" />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} className="content_left">
                            <div className="banner-adv zoom-image">
                                <Row className="necklaces_bg w-100 m-auto">
                                    <Col xs={5} sm={5} md={6} lg={6} className="ring_left_inner no-padding adv-thumb-link">
                                        <img src={necklacesImg} alt="Rings" className='mt-0' />
                                    </Col>
                                    <Col xs={7} sm={7} md={6} lg={6} className="content_left_inner">
                                        <h2>DIAMOND NECKLACES</h2>
                                        <p>A Brilliant Statement</p>
                                        <NavLink to="/jewellery/necklaces" className="cool-link">shop NECKLACES</NavLink>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} className="content_right">
                            <div className="banner-adv zoom-image">
                                <Row className="bracelets_bg w-100 m-auto">
                                    <Col xs={7} sm={7} md={6} lg={6} className="content_right_inner">
                                        <h2>DIAMOND BRACELETS</h2>
                                        <p>Effortlessly Chic</p>
                                        <NavLink to="/jewellery/diamond-bracelets" className="cool-link">shop BRACELETS</NavLink>
                                    </Col>
                                    <Col xs={5} sm={5} md={6} lg={6} className="dfl_finr_coll_bracelet_img no-padding adv-thumb-link desktop_view">
                                        <img src={braceletsImg} alt="Earrings" />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} className="content_left">
                            <div className="banner-adv zoom-image">
                                <Row className="pendants_bg  w-100 m-auto">
                                    <Col xs={5} sm={5} md={6} lg={6} className="ring_left_inner no-padding adv-thumb-link">
                                        <img src={pendantsImg} alt="Rings" className='mt-0' />
                                    </Col>
                                    <Col xs={7} sm={7} md={6} lg={6} className="content_left_inner">
                                        <h2>DIAMOND PENDANTS</h2>
                                        <p>A Forever Gift</p>
                                        <NavLink to="/jewellery/diamond-pendants" className="cool-link">shop Pendants</NavLink>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} className="content_right">
                            <div className="banner-adv zoom-image">
                                <Row className="guid_bg  w-100 m-auto">
                                    <Col xs={7} sm={7} md={6} lg={6} className="content_right_inner">
                                        <h2>SIZE GUIDE</h2>
                                        <p>Find the right size for your Jewellery.</p>
                                        <NavLink to="#" className="cool-link" onClick={() => window.open("https://venice.demobw.com/assets/images/eng-ring/Ring-sizing-guide.pdf", "_blank")}>Ring Size  Guide</NavLink>
                                    </Col>
                                    <Col xs={5} sm={5} md={6} lg={6} className="dfl_finr_coll_bracelet_img no-padding adv-thumb-link ringsize_left_inner ">
                                        <img src={size_guideImg} alt="Earrings" />
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default FineCollection